// extracted by css-extract-rspack-plugin
export default {"container":"tTKAqEhO4MRkKH4C","digitInput":"Vrfu9WAyFDwo1VsY","active":"UBuhHmADg9wdxt8k"};